import api from './api';

const VAPID_PUBLIC = 'BA_iL8On4DV7uWUgtp7TTsVe6DNkm13OiJOTCES1sI2TygmrUgwX3IUT-CSFrqs-kgOVIc69a1BqitGV6Jhn920';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = atob(base64);
  return Uint8Array.from([...raw].map(c => c.charCodeAt(0)));
}

// navigator.serviceWorker.ready no resuelve nunca si no hay SW registrado, y sin
// timeout la promesa se queda colgada y el flujo entero se congela en silencio.
async function registroListo(msTimeout = 8000) {
  return Promise.race([
    navigator.serviceWorker.ready,
    new Promise((_, rechazar) => setTimeout(() => rechazar(new Error('service worker no disponible')), msTimeout)),
  ]);
}

export async function isPushSupported() {
  return 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
}

export async function getPushPermission() {
  return typeof Notification !== 'undefined' ? Notification.permission : 'unsupported';
}

export async function subscribeToPush() {
  const reg = await registroListo();
  const existing = await reg.pushManager.getSubscription();
  if (existing) return existing;

  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC),
  });
  return sub;
}

export async function unsubscribeFromPush() {
  const reg = await registroListo();
  const sub = await reg.pushManager.getSubscription();
  if (sub) await sub.unsubscribe();
  return sub;
}

// Por el cliente axios, no fetch con ruta fija: así respeta REACT_APP_API_URL y
// manda las credenciales igual que el resto de la app.
export async function savePushSubscription(sub) {
  const json = sub.toJSON();
  await api.post('/push-subscribe', { endpoint: json.endpoint, keys: json.keys });
}

export async function deletePushSubscription(sub) {
  const json = sub.toJSON();
  await api.delete('/push-subscribe', { data: { endpoint: json.endpoint } });
}

// Si el permiso ya está concedido, asegura que el navegador tenga suscripción y
// que el backend la conozca. Una vez por sesión: antes se hacía un POST en cada
// carga de la app.
export async function sincronizarSuscripcion() {
  if (!(await isPushSupported())) return;
  if (Notification.permission !== 'granted') return;
  if (sessionStorage.getItem('push_sincronizado') === '1') return;
  try {
    const sub = await subscribeToPush();
    await savePushSubscription(sub);
    sessionStorage.setItem('push_sincronizado', '1');
  } catch {
    // sin service worker o sin red: se reintenta en la siguiente sesión
  }
}
